import { FormLabelOptional, Typography, VisuallyHidden } from '@vp/swan'
import { useTranslation } from 'react-i18next'

export const RequiredIndicator = () => {
  const { t } = useTranslation()
  return (
    <>
      <Typography as="span" aria-hidden="true">
        *
      </Typography>
      <VisuallyHidden>{t('common.required')}</VisuallyHidden>
    </>
  )
}

export const OptionalIndicator = () => {
  const { t } = useTranslation()
  return <FormLabelOptional>{' ' + t('common.optional')}</FormLabelOptional>
}
